export const buildQueryUrlFromObject = (obj) => {
  if (!obj) return '';
  return Object.entries(obj)
    .filter(([, value]) => value) // filter out object without value
    .map(([key, value]) => [key, value].join('=')) // build key value pair
    .join('&'); // concat to string with &
};
